import { TerminationType } from 'features/call/call-base/enums';

interface VrsConferenceTerminationParams {
  currentTerminationType: TerminationType;
  interpretTime: number;
  didAgentGetConnectedToConferenceRoom: boolean;
}

export const vrsConferenceTerminationDecider = ({
  currentTerminationType,
  interpretTime,
  didAgentGetConnectedToConferenceRoom,
}: VrsConferenceTerminationParams): TerminationType => {
  if (currentTerminationType === TerminationType.NonBill) {
    return TerminationType.NonBill;
  }
  if (interpretTime > 0) {
    return TerminationType.Normal;
  }

  return didAgentGetConnectedToConferenceRoom
    ? TerminationType.NoAnswer
    : TerminationType.ClNtPlcd;
};
